module.exports = __webpack_public_path__ + "static/media/classplusLogo-grey.92add339.svg";